import CreateHomework from './create-homework';

export default CreateHomework;
